<script>
  import {getStyleValue} from "../../Common/tools"

  export let data, meta, globalStyle, onChange;

  $: if (!data.button.style) data.button.style = {};

</script>

<tr>
  <th>
    <table style="width: {getStyleValue(globalStyle.width, 600)}px">
      <tr>
        <th class="column mobile-12" style="padding-left: 40px; padding-right: 10px; text-align: left">
            <div class="editor" style="font-family: {data.heading.style.fontFamily}; font-size: {data.heading.style.fontSize}px; font-weight: {data.heading.style.fontWeight}; color: {data.heading.style.color}">
              {data.heading.text}
            </div>
        </th>
        <th class="column mobile-12 mobile-padding-top" style="text-align: {data.button.buttonStyle.position}; padding-left: 10px; padding-right: 40px">
          <div style="border: 0 solid {data.button.buttonStyle.backgroundColor}; border-radius: 3px; background-color: {data.button.buttonStyle.backgroundColor}; font-weight: 400; line-height: 1.4; display: inline-block; padding: 15px 50px 15px 50px; text-decoration: none; text-align: center;" class="email-button">
            <span style="font-family: {data.button.buttonStyle.fontFamily}; font-size: {data.button.buttonStyle.fontSize}px; font-weight: {data.button.buttonStyle.fontWeight}; color: {data.button.buttonStyle.color};">
              {data.button.text}
            </span>
          </div>
        </th>
      </tr>
      <tr>
        <td colspan="2" class="column mobile-8" style="padding-left: 40px; padding-right: 10px; padding-top: 15px; text-align: left">
          <div class="editor" style="font-family: {data.footer.style.fontFamily}; font-size: {data.footer.style.fontSize}px; font-weight: {data.footer.style.fontWeight}; color: {data.footer.style.color}">
            {data.footer.text}
          </div>
        </td>
      </tr>
    </table>
  </th>
</tr>
